import { useT } from "../lib/i18n.tsx";

/** "👁 14 · 🔔 6" with accessible text. */
export function Counts({ watching, alerts }: { watching: number; alerts: number }) {
  const t = useT();
  return (
    <span className="counts">
      <span title={t("counts.watching", { n: watching })}>
        <span aria-hidden="true">👁</span> {watching}
      </span>
      <span className="counts__sep" aria-hidden="true">
        ·
      </span>
      <span title={t("counts.alerts", { n: alerts })}>
        <span aria-hidden="true">🔔</span> {alerts}
      </span>
    </span>
  );
}
